import React, { ReactElement, useEffect, useState } from 'react';
import './index.less';
import { useLocation } from 'react-router-dom';
import bigCircular from '@assets/big-circular.png';
import greyCircular from '@assets/grey-circular.png';
import { getInstallProgress } from '../../../../api/filling-pile';
import { getLoginInfoPromise } from '../../../../utils/common';
import { formateDatePile } from '../../../../utils/common';
import redCirdular from '@assets/red-circular.png';

const OldInstalling = (): ReactElement => {
  const [installInfo, setInstallInfo] = useState<any>();
  const loc = useLocation();
  console.log('loc', loc.search);
  const orderNo: any = new URLSearchParams(loc.search).get('orderNo');
  const setTitle = () => {
    document.title = '报装家充桩';
  };
  const isInstallComplete = () => {
    if (
      installInfo.orderStatus === '21' ||
      installInfo.orderStatus === '24' ||
      installInfo.orderStatus === '33'
    ) {
      return bigCircular;
    }
    return greyCircular;
  };
  const isInstallation = () => {
    if (
      installInfo.orderStatus === '15' ||
      installInfo.orderStatus === '18' ||
      installInfo.orderStatus === '21' ||
      installInfo.orderStatus === '24' ||
      installInfo.orderStatus === '33'
    ) {
      return bigCircular;
    }
    return greyCircular;
  };
  const isSurvey = () => {
    if (
      installInfo.orderStatus === '09' ||
      installInfo.orderStatus === '12' ||
      installInfo.orderStatus === '15' ||
      installInfo.orderStatus === '18' ||
      installInfo.orderStatus === '21' ||
      installInfo.orderStatus === '24' ||
      installInfo.orderStatus === '33'
    ) {
      return bigCircular;
    }
    return greyCircular;
  };
  useEffect(() => {
    setTitle();
    getLoginInfoPromise().then(res => {
      getInstallProgress({ uid: res.uid, orderNo }).then(info => {
        console.log(info.data);
        setInstallInfo(info.data);
      });
    });
  }, []);

  return (
    <div className="old-install">
      <div className="content">
        <div
          className="site-survey"
          style={
            installInfo && {
              display: installInfo.orderStatus === '30' ? 'none' : 'block'
            }
          }
        >
          <div>
            <p>已安装</p>
          </div>
          <img
            src={installInfo && isInstallComplete()}
            alt=""
            className="bigCircular"
          />
        </div>
        <div
          className="site-survey"
          style={
            installInfo && {
              display: installInfo.orderStatus === '30' ? 'none' : 'block'
            }
          }
        >
          <div>
            <p>安装中</p>
          </div>
          <img
            src={installInfo && isInstallation()}
            alt=""
            className="bigCircular"
          />
        </div>

        <div
          className="site-survey"
          style={
            installInfo && {
              display: installInfo.orderStatus === '30' ? 'none' : 'block'
            }
          }
        >
          <div>
            <p>勘测中</p>
          </div>
          <img src={installInfo && isSurvey()} alt="" className="bigCircular" />
        </div>
        {installInfo && installInfo.orderStatus === '30' ? (
          <div className="site-survey">
            <div>
              <p>中途结束</p>
            </div>
            <img src={redCirdular} alt="" className="bigCircular" />
          </div>
        ) : (
          ''
        )}
        <div className="title">
          <div className="text">已建单</div>
          <img src={bigCircular} alt="" className="bigCircular" />
          {installInfo && installInfo.applyInstallationDate ? (
            <div className="time">
              申请时间：
              {installInfo &&
                formateDatePile(installInfo.applyInstallationDate)}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="contact">
        {installInfo && installInfo.serviceProviderManagerPhone ? (
          <a
            href={`tel:${installInfo &&
              installInfo.serviceProviderManagerPhone}`}
          >
            联系家充管家
          </a>
        ) : (
          <div className="text">正在为您分配家充管家</div>
        )}
      </div>
    </div>
  );
};
export default OldInstalling;
